import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 20v-12a4 4 0 0 1 4 -4h2a4 4 0 0 1 4 4v12","key":"svg-0"}],["path",{"d":"M7 13l10 0","key":"svg-1"}]]

const IconLetterA = createReactComponent('outline', 'letter-a', 'LetterA', __iconNode);

export default IconLetterA;